import {
  MobileRow,
  MobileRowTitle,
  MobileRowValue,
  MobileTableRowWrap,
  MobileTableWrapper,
  NoResults
} from '@/components/table/mobileTable/mobileTable';
import { dateFormatter } from '@/shared/utils/date';
import guid from '@/shared/utils/guid';
import { format } from 'date-fns';
import { docusignRoutingTableColumns } from '../../constants';
import { EnvelopeRecipientDto } from '../../types';

interface MobileTableProps {
  docusignRoutingTableData: EnvelopeRecipientDto[];
}

const MobileTable = ({ docusignRoutingTableData }: MobileTableProps) => {
  const TableRow = ({ el }: { el: EnvelopeRecipientDto }) => {
    return (
      <MobileTableRowWrap>
        <MobileRow>
          <MobileRowTitle>{docusignRoutingTableColumns[0].title}</MobileRowTitle>
          <MobileRowValue>{el.routingOrder}</MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{docusignRoutingTableColumns[1].title}</MobileRowTitle>
          <MobileRowValue>{el?.completedAt && dateFormatter(format(new Date(el.completedAt), 'yyyy-MM-dd'), 'yyyy-MM-dd')}</MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{docusignRoutingTableColumns[2].title}</MobileRowTitle>
          <MobileRowValue>{el.role}</MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{docusignRoutingTableColumns[3].title}</MobileRowTitle>
          <MobileRowValue>{el.name}</MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{docusignRoutingTableColumns[4].title}</MobileRowTitle>
          <MobileRowValue>{el.email}</MobileRowValue>
        </MobileRow>
      </MobileTableRowWrap>
    );
  };

  return (
    <MobileTableWrapper>
      {docusignRoutingTableData.length ? (
        docusignRoutingTableData.map((el) => {
          return <TableRow el={el} key={guid()} />;
        })
      ) : (
        <NoResults>No Results</NoResults>
      )}
    </MobileTableWrapper>
  );
};

export default MobileTable;
